import type { ThemeConfig } from 'antd';

export const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
    colorBgBase: '#ffffff',
  },
};

export const darkTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
    colorBgBase: '#1f1f1f',
    colorBgContainer: '#2a2a2a',
    colorText: '#ffffff',
    colorBorder: '#404040',
  },
  algorithm: undefined, // Will be set by ConfigProvider
};
